import { render, staticRenderFns } from "./RegisterHeader.vue?vue&type=template&id=0200a757"
import script from "./RegisterHeader.vue?vue&type=script&lang=js"
export * from "./RegisterHeader.vue?vue&type=script&lang=js"
import style0 from "./RegisterHeader.vue?vue&type=style&index=0&id=0200a757&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports